import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto py-16" data-testid="payment-cancel-page">
      <Card className="p-10 bg-card border-border text-center">
        <XCircle className="h-14 w-14 mx-auto text-amber-400 mb-4" />
        <h1 className="font-display text-2xl font-bold mb-2">Paiement annulé</h1>
        <p className="text-muted-foreground text-sm mb-6">Vous pouvez reprendre l'abonnement quand vous serez prêt.</p>
        <Link to="/tarifs"><Button className="bg-cyan-500 hover:bg-cyan-400 text-slate-950">Retour aux tarifs</Button></Link>
      </Card>
    </div>
  );
}
